import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Menu, MenuItemProps } from 'antd';
import { SignOutButtonMenuItem } from 'components/button/button-sign-out/sign-out-button';
import { User } from 'features/auth';

const styles = {
  sideMenu: { fontFamily: 'Comfortaa', borderRadius: '0px 0px 20px 0px' },
  avatarContainer: {
    display: 'flex',
    justifyContent: 'center',
    height: '32px',
    width: '32px',
    background: 'transparent'
  },
  avatar: { color: 'rgba(118, 118, 121, 1)' },
  avatarLabel: {
    borderBottom: '1px solid rgba(163, 102, 252, 0.25)',
    color: 'rgba(36, 36, 37, 1)'
  },

  collapseContainer: {
    height: '32px',
    width: '32px',
    borderRadius: '16px',
    background: 'rgba(228, 230, 235, 1)'
  },
  collapseIcon: {
    display: 'flex',
    justifyContent: 'center',
    height: '32px',
    width: '32px'
  }
};

interface SideMenuFooterProps {
  collapsed: boolean;
  onClick: MenuItemProps['onClick'];
  user: User;
}
export function SideMenuFooter(props: SideMenuFooterProps) {
  // console.log("user: ", user.photoURL, photoURL);
  const label = props.collapsed ? '' : 'Collapse';

  /**
   * Don't render the menu if the user data is not loaded
   */
  if (!props.user) return null;

  return (
    <Menu
      className={'nohighlight'}
      style={{
        ...styles.sideMenu,
        borderRight: 'none'
      }}
    >
      {/* <Menu.Item className={'nohighlight'}>
        <SignOutButton rounded />
      </Menu.Item> */}
      <SignOutButtonMenuItem />
      <Menu.Item
        className={'nohighlight'}
        onClick={props.onClick}
        icon={props.collapsed ? <RightOutlined /> : <LeftOutlined />}
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        }}
      >
        {label}
      </Menu.Item>
    </Menu>
  );
}
